import {
    Camera,
    XCircle,
    ShieldCheck,
    Layers3,
    Move3D,
    AlignHorizontalJustifyStart,
    ScanLine,
} from 'lucide-react';
import { motion } from 'framer-motion';

const techFeatures = [
    {
        icon: <XCircle className="w-8 h-8 text-teal-500 mb-4" />,
        title: 'Digital X-Rays',
        desc: 'Faster, clearer, and up to 80% less radiation than traditional film X-rays. Results appear instantly and are easier to share and store.',
    },
    {
        icon: <Camera className="w-8 h-8 text-lime-500 mb-4" />,
        title: 'Intraoral Cameras',
        desc: 'Tiny cameras give you a clear, real-time view of your mouth so you can see exactly what your dentist sees.',
    },
    {
        icon: <Move3D className="w-8 h-8 text-teal-500 mb-4" />,
        title: '3D Cone Beam Imaging (CBCT)',
        desc: 'Used for implants, root canals, and surgery planning. It provides detailed, 360° views of your jaw, teeth, and bone structure.',
    },
    {
        icon: <AlignHorizontalJustifyStart className="w-8 h-8 text-lime-500 mb-4" />,
        title: 'Digital Impressions',
        desc: 'No more gooey trays! Digital scans create precise 3D models for crowns, bridges, and Invisalign.',
    },
    {
        icon: <ScanLine className="w-8 h-8 text-teal-500 mb-4" />,
        title: 'iTero Scanner',
        desc: 'Accurate and fast Invisalign scans with 3D visualizations of your treatment outcome.',
    },
    {
        icon: <ShieldCheck className="w-8 h-8 text-lime-500 mb-4" />,
        title: 'Laser Dentistry',
        desc: 'Minimally invasive treatment for gums, cold sores, and more—often with no anesthesia required.',
    },
    {
        icon: <Layers3 className="w-8 h-8 text-teal-500 mb-4" />,
        title: 'Same-Day Provisional Crowns',
        desc: 'We value your time and comfort. That\'s why we offer same-day provisional crowns!',
    },
];

const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.1, duration: 0.5, ease: 'easeOut' },
    }),
};

export default function TechnologiesWeUse() {
    return (
        <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center space-y-6">
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
                    Technologies We Use
                </h2>
                <p className="text-lg text-gray-600">
                    At Pristine Smile, we invest in the latest technology to ensure more precise care, less discomfort, and better outcomes—every time.
                </p>
            </div>

            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
                {techFeatures.map((feature, i) => (
                    <motion.div
                        key={i}
                        custom={i}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={cardVariants}
                        className="bg-gradient-to-br from-teal-50 to-lime-50 p-6 rounded-xl shadow-md hover:shadow-lg transition"
                    >
                        {feature.icon}
                        <h3 className="text-xl font-semibold text-teal-600">{feature.title}</h3>
                        <p className="text-gray-700 mt-2">{feature.desc}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}